module.exports = __webpack_public_path__ + "static/media/19.5153e268.jpg";